import * as React from 'react'
import { Card, Descriptions } from 'antd'
import { DepositEdit } from '../../edit/types'

type Props = {
  deposit: DepositEdit
}

export const DepositCommissionsBlock = ({ deposit }: Props) => (
  <Card size="small" title="Commissions">
    <Descriptions size="small" column={{ xs: 1, sm: 2, lg: 3 }} bordered>
      <Descriptions.Item label="Commission currency">
        {deposit.commissionCurrency}
      </Descriptions.Item>
      <Descriptions.Item label="Client commission">
        {deposit.clientCommission}
      </Descriptions.Item>
      <Descriptions.Item label="Company commission">
        {deposit.companyCommission}
      </Descriptions.Item>
      <Descriptions.Item label={`Inner commission ${deposit.initialCurrency}`}>
        {deposit.innerCommission ?? 0}
      </Descriptions.Item>
      <Descriptions.Item label="Estimated commission">
        {deposit.estimatedCommission ?? 0}
      </Descriptions.Item>
    </Descriptions>
  </Card>
)
